import cmp from './ConfirmSignUp'

export default cmp
